import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/bodyScrollLock'; 


$(document).foundation();


/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */


let prevScrollpos = window.scrollY;

const elNavBar = document.getElementById("navbar");

window.addEventListener("scroll", function () {
  const currentScrollPos = window.scrollY;

  // Clear all scroll direction classes
  elNavBar.classList.remove("going-up", "going-down", "top-floor");

  if (currentScrollPos === 0) {
    elNavBar.classList.add("top-floor");
  } else if (currentScrollPos < prevScrollpos || currentScrollPos < 50) {
    elNavBar.classList.add("going-up");

    
  } else {
    elNavBar.classList.add("going-down");

  }

  prevScrollpos = currentScrollPos;
});




    /* NAV OVERLAY  */  

    $('.btn-open-menu').on('click', function(e) {
        e.preventDefault();
        $('.overlay').addClass('open');
    });
   

    $('.btn-close-menu').on('click', function(e) {
        e.preventDefault();
        $('.overlay').removeClass('open');   
    });


    $('.overlay').on('click', function(e) {     
        $('.overlay').removeClass('open');   
    });





  

const videoInitAnimations = document.querySelectorAll('.play-me');

const videoInitAnimationsObserver = new IntersectionObserver((entries) => {

  entries.forEach(entry => {

    if (entry.intersectionRatio > 0) {
      entry.target.classList.remove('pause-now');
      entry.target.classList.add('play-now');
      entry.target.play();
    } else { 
      entry.target.classList.remove('play-now');
      entry.target.classList.add('pause-now');
      entry.target.pause(); 
    }

  });
  
});

videoInitAnimations.forEach(videoInitAnimate => {
  videoInitAnimationsObserver.observe(videoInitAnimate); 
});





if (document.body.classList.contains('page-pricing')) {

  console.log('Body has the class');

  const pricingHeaders = document.querySelectorAll('.content-text-only');

  pricingHeaders.forEach((header, index, arr) => {

    console.log(header);

    if (index === 0) {
      header.classList.add('content-text-only--no-border');
    }
    if (index === 1) {
      header.classList.add('content-text-only--no-border');
    }
    else if(index > 1) {
      header.classList.add('content-text-only--pricing-page');
    }

    if (index === arr.length - 1) {
      header.classList.add('last-item');
    }

  });
  
} 


